import React, { useEffect, useState } from "react";
import Inner_Footer_Text_Component from "../common_components/inner_footer_text_component/Inner_Footer_Text_Component";
import { getAllLegalDocument } from "../../utils/apis/content/content";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const Legal_Documents = () => {
  const navigate = useNavigate();

  const [legalDocument, setLegalDocument] = useState("");
  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const getLegalDocument = async () => {
    const res = await getAllLegalDocument();
    if (res?.success) {
      setLegalDocument(res.data);
    }
  };

  useEffect(() => {
    getLegalDocument();
  }, []);
  return (
    <section className="Legal_Documents About_Profile">
      <div className="heading_div">
        <div className="row">
          <div className="col-8">
            <p className="info_page_title">Legal documents</p>
          </div>
          <div className="col-4 text-end">
            <FontAwesomeIcon
              className="colpa-close"
              icon={faXmark}
              onClick={() => navigate(-1)}
            />
          </div>
        </div>
      </div>
      <div className="info_div">
        <p className="info_text">
          {htmlToReactParser.parse(legalDocument?.name)}
        </p>
      </div>

      <div className="footer_div">
        <Inner_Footer_Text_Component />
      </div>
    </section>
  );
};

export default Legal_Documents;
